import { inherits as _inherits, createSuper as _createSuper, classCallCheck as _classCallCheck, createClass as _createClass } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { __rest } from '../../_virtual/_tslib.js';
import { ParagraphPresentation } from '@lsg/shared';
import { createElement, Component } from 'react';

/** @deprecated, replaced by union type */
var Sizes;
(function (Sizes) {
  Sizes["DEFAULT"] = "copy-text";
  Sizes["HELPER"] = "helper-text";
  Sizes["LEAD"] = "lead-text";
  Sizes["ERROR"] = "error-text";
  Sizes["INFO"] = "info-text";
})(Sizes || (Sizes = {}));
var Paragraph = /*#__PURE__*/function (_Component) {
  _inherits(Paragraph, _Component);
  var _super = _createSuper(Paragraph);
  function Paragraph() {
    _classCallCheck(this, Paragraph);
    return _super.apply(this, arguments);
  }
  _createClass(Paragraph, [{
    key: "render",
    value: function render() {
      var _a = this.props,
        children = _a.children,
        size = _a.size,
        centeredLayout = _a.centeredLayout,
        props = __rest(_a, ["children", "size", "centeredLayout"]);
      return /*#__PURE__*/createElement(ParagraphPresentation, Object.assign({
        size: size,
        centeredLayout: centeredLayout
      }, props), children);
    }
  }]);
  return Paragraph;
}(Component);
Paragraph.displayName = "Paragraph";
Paragraph.defaultProps = {
  size: "copy-text"
};
/** @deprecated */
Paragraph.Sizes = Sizes;

export { Paragraph };
